import styled from "styled-components";
import { FlexRowDiv } from "../common.styles";
import { HXMobilePageWithFixedHeaderAndFooterContainer, HXMobilePageWithFixedHeaderAndFooterContent } from "../HXMobilePage.styles";
import { colors } from "healthex-common/colors";
export const AddPatientMethodParent = styled(HXMobilePageWithFixedHeaderAndFooterContainer).attrs({
    overflowYHidden: false,
}) ``;
export const AddPatientMethodContent = styled(HXMobilePageWithFixedHeaderAndFooterContent).attrs({
    isHeaderAndFooterFixed: true,
}) `
    padding: 32px 24px 48px 24px;
`;
export const AddPatientMethodFooterContainer = styled(FlexRowDiv) `
    padding: 16px 24px;
    border-top: 1px solid ${colors.black_12};
    justify-content: flex-end;
    align-items: center;
    align-self: stretch;
`;
export const ShareLinkParent = styled(HXMobilePageWithFixedHeaderAndFooterContainer).attrs({
    overflowYHidden: false,
}) `
    padding: 16px 24px;
`;
